import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Card } from "@material-ui/core";
import Pie from "../../../../../Component/Charts/Pie";
import config from "../config";
import { onGoingcheckStatuses } from "../../../../../API/config";
const { chartColors } = config;

const CheckSummary = (props) => {
  const { t } = useTranslation();
  const {
    checksByStatus = [],
    recordsByType = [],
    checksByScore = [],
    classes,
  } = props;

  const [totalChecks, setTotalChecks] = useState(0);
  const [totalChecksByStatus, setTotalChecksByStatus] = useState([]);

  const [ongoingChecks, setOngoingChecks] = useState(0);
  const [ongoingChecksByStatus, setOngoingChecksByStatus] = useState([]);

  const [kycChecks, setKycChecks] = useState(0);
  const [kycChecksByStatus, setKycChecksByStatus] = useState([]);

  const [amlChecks, setAmlChecks] = useState(0);
  const [amlChecksByStatus, setAmlChecksByStatus] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalRecordsByType, setTotalRecordsByType] = useState([]);

  const [totalChecksByScore, setTotalChecksByScore] = useState([]);
  const [totalChecksFiltered, setTotalChecksFiltered] = useState(0);

  useEffect(() => {
    const getCheckColorByStatus = (status) => {
      let color = "";
      switch (status) {
        case "Expired":
          color = chartColors.stateColors.expired;
          break;
        case "Escalated":
          color = chartColors.stateColors.inApproval;
          break;
        case "Blocked":
          color = chartColors.stateColors.rejected;
          break;
        case "Proceed At Risk":
          color = chartColors.stateColors.approved;
          break;
        case "Incomplete":
          color = chartColors.stateColors.incomplete;
          break;
        case "Approved":
          color = chartColors.stateColors.approved;
          break;
        case "Referred To Deal Team":
          color = chartColors.stateColors.inProgress;
          break;
        case "Under Review":
          color = chartColors.stateColors.inProgress;
          break;
        case "Request Sent":
          color = chartColors.stateColors.inProgress;
          break;
      }

      return color;
    };

    let totalChecks = 0;
    let totalChecksByStatus = [];

    let ongoingChecks = 0;
    let ongoingChecksByStatus = [];

    let kycChecks = 0;
    let kycChecksByStatus = [];

    let amlChecks = 0;
    let amlChecksByStatus = [];

    let totalRecords = 0;
    let totalRecordsByType = [];

    const totalChecksByScore = [];
    let totalChecksFiltered = 0;

    (checksByStatus || []).forEach((item) => {
      totalChecks += item.no_of_checks;

      let td = totalChecksByStatus.find((td) => td.name === item.check_status);

      if (!td) {
        td = {
          name: item.check_status,
          value: item.no_of_checks,
          color: getCheckColorByStatus(item.check_status),
        };
        totalChecksByStatus.push(td);
      } else {
        td.value += item.no_of_checks;
      }

      if (onGoingcheckStatuses.includes(item.check_status)) {
        ongoingChecks += item.no_of_checks;
        let td = ongoingChecksByStatus.find(
          (td) => td.name === item.check_status,
        );
        if (!td) {
          td = {
            name: item.check_status,
            value: item.no_of_checks,
            color: getCheckColorByStatus(item.check_status),
          };
          ongoingChecksByStatus.push(td);
        } else {
          td.value += item.no_of_checks;
        }
      }
      if (item.check_type === "KYC") {
        kycChecks += item.no_of_checks;
        let td = kycChecksByStatus.find((td) => td.name === item.check_status);
        if (!td) {
          td = {
            name: item.check_status,
            value: item.no_of_checks,
            color: getCheckColorByStatus(item.check_status),
          };
          kycChecksByStatus.push(td);
        } else {
          td.value += item.no_of_checks;
        }
      }
      if (item.check_type === "AML") {
        amlChecks += item.no_of_checks;
        let td = amlChecksByStatus.find((td) => td.name === item.check_status);
        if (!td) {
          td = {
            name: item.check_status,
            value: item.no_of_checks,
            color: getCheckColorByStatus(item.check_status),
          };
          amlChecksByStatus.push(td);
        } else {
          td.value += item.no_of_checks;
        }
      }
    });

    (recordsByType || []).forEach((item) => {
      totalRecords += item.no_of_records;
      let td = totalRecordsByType.find((td) => td.name === item.score);
      if (!td) {
        let color = null;

        switch (item.entity_category) {
          case "Legal Person":
            color = chartColors.entityColors.legalPerson;
            break;
          case "Natural Person":
            color = chartColors.entityColors.naturalPerson;
            break;
          case "Others":
            color = chartColors.entityColors.others;
            break;
          default:
            color = null;
            break;
        }
        td = {
          name: item.entity_category,
          value: item.no_of_records,
          color,
        };
        totalRecordsByType.push(td);
      } else {
        td.value += item.no_of_records;
      }
    });

    checksByScore.forEach((item) => {
      totalChecksByScore.push({
        value: item.no_of_checks,
        name: item.score,
        color: chartColors["statusColors"][item.score.toLowerCase()],
      });

      totalChecksFiltered += item.no_of_checks;
    });

    setTotalChecks(totalChecks);
    setTotalChecksByStatus(totalChecksByStatus);
    setOngoingChecks(ongoingChecks);
    setOngoingChecksByStatus(ongoingChecksByStatus);
    setKycChecks(kycChecks);
    setKycChecksByStatus(kycChecksByStatus);
    setAmlChecks(amlChecks);
    setAmlChecksByStatus(amlChecksByStatus);
    setTotalRecords(totalRecords);
    setTotalRecordsByType(totalRecordsByType);
    setTotalChecksByScore(totalChecksByScore);
    setTotalChecksFiltered(totalChecksFiltered);
  }, [checksByStatus, recordsByType, checksByScore]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <Card elevation={0} variant="outlined" style={{ padding: 5 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Pie
                title={t("labels.dashboard.checkSummary.totalChecks")}
                subTitle={totalChecks || 0}
                data={totalChecksByStatus}
                height={150}
              />
            </Grid>
            <Grid item xs={3}>
              <Pie
                title={t("labels.dashboard.checkSummary.ongoingChecks")}
                subTitle={ongoingChecks || 0}
                data={ongoingChecksByStatus}
                height={150}
              />
            </Grid>
            <Grid item xs={3}>
              <Pie
                title={t("labels.dashboard.checkSummary.kycChecks")}
                subTitle={kycChecks || 0}
                data={kycChecksByStatus}
                height={150}
              />
            </Grid>
            <Grid item xs={3}>
              <Pie
                title={t("labels.dashboard.checkSummary.amlChecks")}
                subTitle={amlChecks || 0}
                data={amlChecksByStatus}
                height={150}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={4}>
        <Card elevation={0} variant="outlined" style={{ padding: 5 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Pie
                title={t("labels.dashboard.checkSummary.scoreAnalysis")}
                subTitle={totalChecksFiltered || 0}
                data={totalChecksByScore}
                height={150}
              />
            </Grid>
            <Grid item xs={6}>
              <Pie
                title={t("labels.dashboard.checkSummary.entityTypes")}
                subTitle={totalRecords || 0}
                data={totalRecordsByType}
                height={150}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CheckSummary;
